"use strict";
$(function ($) {
 
  /*スライダー,spride */
  const options1 ={
    type: 'fade',
    pagination: false, // ページネーションを非表示
    arrows: false,//矢印の非表示
    autoplay: true,//自動再生
    rewind: true,//最後まで行ったら巻き戻す
    pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
    pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
    interval: 4000, // 自動再生の画像切り替えの間隔
    updateOnMove: true,
  }
//   const 任意の変数名B = new Splide( '対象のスライドショーのクラス名orid名', 任意の変数名A);
// 任意の変数名B.mount();
  const splide1 = new Splide('#js-fv__slider',options1)
  splide1.mount()

  /*worksスライダー,spride*/
  const options2 ={
    mediaQuery: 'min',
    pagination: false, // ページネーションを非表示
    type: "loop", // デフォルトはスライド（slide）
    rewind: true,//最後まで行ったら巻き戻す
    arrows: false,//矢印の非表示
    pauseOnHover: false, // カーソルが乗ってもスクロールを停止させない
    pauseOnFocus: false, // 矢印をクリックしてもスクロールを停止させない
    gap: 24, // スライド間の余白
    padding: { left: 0, right: "40%" },
    updateOnMove: true,
    breakpoints: {
      780: {
        gap: 16,
        padding: { left: "0%", right: "60%" },
      }
    }
  }
  const splide2 = new Splide('#js-works__slider',options2)
  splide2.mount()

  /*accessタブ切り替え*/
  $('.js-tab').on('click', function(){
    $('.js-tab,.js-panel').removeClass('active');
    $(this).addClass('active');
    const index =$('.js-tab').index(this);
    $('.js-panel').eq(index).addClass('active');
  });

});
